import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  showAdditionalHeaderCTA: boolean;
  showLogin: boolean;
};

interface UseHeaderLayout extends State {
  setState: (state: Partial<UseHeaderLayout>) => void;
}

const initialState = {
  showAdditionalHeaderCTA: false,
  showLogin: true,
};

export const useHeaderLayout = create<UseHeaderLayout>()(
  devtools(set => ({
    ...initialState,
    setState: args => set({ ...args }),
  })),
);
